import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// constants
import {
  LAYOUT_TYPES,
  LAYOUT_MODE_TYPES,
  LAYOUT_WIDTH_TYPES,
  LAYOUT_POSITION_TYPES,
  LAYOUT_TOPBAR_THEME_TYPES,
  LAYOUT_SIDEBAR_TYPES,
  LEFT_SIDEBAR_SIZE_TYPES,
  LEFT_SIDEBAR_VIEW_TYPES,
  LEFT_SIDEBAR_IMAGE_TYPES,
  PERLOADER_TYPES,
  SIDEBAR_VISIBILITY_TYPES,
} from "../../Components/constants/layout";


/* ---------- State Type ---------- */

interface LayoutState {
  layoutType: string;
  leftSidebarType: string;
  layoutModeType: string;
  layoutWidthType: string;
  layoutPositionType: string;
  topbarThemeType: string;
  leftsidbarSizeType: string;
  leftSidebarViewType: string;
  leftSidebarImageType: string;
  preloader: string;
  sidebarVisibilitytype: string;
}

/* ---------- Initial State ---------- */

export const initialState: LayoutState = {
  layoutType: LAYOUT_TYPES.VERTICAL,
  leftSidebarType: LAYOUT_SIDEBAR_TYPES.DARK,
  layoutModeType: LAYOUT_MODE_TYPES.LIGHTMODE,
  layoutWidthType: LAYOUT_WIDTH_TYPES.FLUID,
  layoutPositionType: LAYOUT_POSITION_TYPES.FIXED,
  topbarThemeType: LAYOUT_TOPBAR_THEME_TYPES.LIGHT,
  leftsidbarSizeType: LEFT_SIDEBAR_SIZE_TYPES.SMALLHOVER,
  leftSidebarViewType: LEFT_SIDEBAR_VIEW_TYPES.DEFAULT,
  leftSidebarImageType: LEFT_SIDEBAR_IMAGE_TYPES.NONE,
  preloader: PERLOADER_TYPES.DISABLE,
  sidebarVisibilitytype: SIDEBAR_VISIBILITY_TYPES.SHOW,
};

/* ---------- Slice ---------- */

const LayoutSlice = createSlice({
  name: "LayoutSlice",
  initialState,
  reducers: {
    changeLayoutAction(
      state,
      action: PayloadAction<string>
    ) {
      state.layoutType = action.payload;
    },
    changeLayoutModeAction(
      state,
      action: PayloadAction<string>
    ) {
      state.layoutModeType = action.payload;
    },
    changeSidebarThemeAction(
      state,
      action: PayloadAction<string>
    ) {
      state.leftSidebarType = action.payload;
    },
    changeLayoutWidthAction(
      state,
      action: PayloadAction<string>
    ) {
      state.layoutWidthType = action.payload;
    },
    changeLayoutPositionAction(
      state,
      action: PayloadAction<string>
    ) {
      state.layoutPositionType = action.payload;
    },
    changeTopbarThemeAction(
      state,
      action: PayloadAction<string>
    ) {
      state.topbarThemeType = action.payload;
    },
    changeLeftsidebarSizeTypeAction(
      state,
      action: PayloadAction<string>
    ) {
      state.leftsidbarSizeType = action.payload;
    },
    changeLeftsidebarViewTypeAction(
      state,
      action: PayloadAction<string>
    ) {
      state.leftSidebarViewType = action.payload;
    },
    changeSidebarImageTypeAction(
      state,
      action: PayloadAction<string>
    ) {
      state.leftSidebarImageType = action.payload;
    },
    changePreLoaderAction(
      state,
      action: PayloadAction<string>
    ) {
      state.preloader = action.payload;
    },
    changeSidebarVisibilityAction(
      state,
      action: PayloadAction<string>
    ) {
      state.sidebarVisibilitytype = action.payload;
    },
  },
});

/* ---------- Actions ---------- */

export const {
  changeLayoutAction,
  changeLayoutModeAction,
  changeSidebarThemeAction,
  changeLayoutWidthAction,
  changeLayoutPositionAction,
  changeTopbarThemeAction,
  changeLeftsidebarSizeTypeAction,
  changeLeftsidebarViewTypeAction,
  changeSidebarImageTypeAction,
  changePreLoaderAction,
  changeSidebarVisibilityAction,
} = LayoutSlice.actions;

/* ---------- Reducer ---------- */

export default LayoutSlice.reducer;

/* ---------- Enums ---------- */

